module.exports = __webpack_public_path__ + "static/media/circledLineAbout.8f23c005.svg";